import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = ['mobileButton', 'desktopButton']

  connect() {
    if ('share' in navigator) {
      document.documentElement.classList.add('has-native-share')
    } else {
      document.documentElement.classList.add('no-native-share')
    }
  }

  async share(event) {
    event.preventDefault()

    try {
      await navigator.share({
        title: document.title,
        text: "Check out this great activity I found on School's Out!",
        url: this.urlValue
      })
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Error sharing:', err)
      }
    }
  }
}
